import { Box } from '@mui/material';
import { type FC } from 'react';

interface Props {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onChange: (value: number) => void;
}

export const EditableQty: FC<Props> = ({
  value,
  onIncrement,
  onDecrement,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        width: '100%',
        maxWidth: '6rem',
      }}
    >
      <Box
        component='button'
        sx={{
          width: '1.5rem',
          height: '1.5rem',
          minWidth: '1.5rem',
          backgroundColor: '#f5f5f5',
          border: '1px solid #ccc',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '0.75rem',
          fontWeight: 'bold',
          color: '#666',
          '&:hover': {
            backgroundColor: '#e0e0e0',
          },
          '&:active': {
            backgroundColor: '#d0d0d0',
          },
        }}
        onClick={onDecrement}
      >
        −
      </Box>
      <Box
        component='input'
        type='number'
        sx={{
          width: '2.5rem',
          height: '1.5rem',
          textAlign: 'center',
          border: '1px solid #ccc',
          borderRadius: '0.25rem',
          fontSize: '0.75rem',
          padding: '0.125rem',
          '&:focus': {
            outline: 'none',
            borderColor: '#1C5B9C',
          },
          '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          '&[type=number]': {
            MozAppearance: 'textfield',
          },
        }}
        value={value}
        onChange={e => {
          const newValue = parseInt(e.target.value) || 0;
          onChange(newValue);
        }}
      />
      <Box
        component='button'
        sx={{
          width: '1.5rem',
          height: '1.5rem',
          minWidth: '1.5rem',
          backgroundColor: '#f5f5f5',
          border: '1px solid #ccc',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '0.75rem',
          fontWeight: 'bold',
          color: '#666',
          '&:hover': {
            backgroundColor: '#e0e0e0',
          },
          '&:active': {
            backgroundColor: '#d0d0d0',
          },
        }}
        onClick={onIncrement}
      >
        +
      </Box>
    </Box>
  );
};
